import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import PaginatedTable from '../../commonComponents/util/PaginatedTable';
import ReferencesTableRow from './ReferencesTableRow';
import ReferenceModal from './ReferenceModal';
import ConfirmationModal from '../../commonComponents/shared/ConfirmationModal';

export default class ReferencesTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = this.initialState;

        this.getTableRow = this.getTableRow.bind(this);
    }

    initialState = {
        selectedRecord: {},
        showModals: {
            editReferenceModal: false,
            confirmationModal: false
        }
    };

    getTableRow(reference) {
        return <ReferencesTableRow key={reference.referenceId}
            reference={reference}
            canManage={this.props.canManage}
            edit={() => this.setState({ selectedRecord: reference }, this.toggleModal.bind(this, "editReferenceModal"))}
            delete={() => this.setState({ selectedRecord: reference }, this.toggleModal.bind(this, "confirmationModal"))} />;
    }

    render() {
        let columns = [
            { title: 'Name', sortable: true, id: 'name' },
            { title: 'Position', sortable: true, id: 'position' },
            { title: 'Phone', sortable: true, id: 'phone' },
            { title: 'Email', sortable: true, id: 'email' },
            { title: 'Address', sortable: true, id: 'address' },
            { title: 'Used As Payee', sortable: true, id: 'isPayee' },
            { title: 'Bank Account', sortable: true, id: 'bankAccount' }
        ];
        if (this.props.canManage) columns.push(
            { title: 'Action', sortable: false, id: 'action' }
        );

        return <div>
            <PaginatedTable
                name="references"
                page={this.props.page}
                totalCount={this.props.data.totalCount}
                resultsView={this.props.resultsView}
                sort={this.props.sort}
                loading={this.props.loading}
                success={this.props.success}
                renderRow={this.getTableRow}
                columns={columns}
                records={this.props.data.records || []}
                sortData={this.props.updateTable}
                changeDataView={this.props.updateTable}
                loadData={this.props.getReferences} />

            <ReferenceModal
                show={this.state.showModals.editReferenceModal}
                close={this.toggleModal.bind(this, "editReferenceModal")}
                reference={this.state.selectedRecord}
                {...this.props.updatingReference}
                submitReference={reference => this.props.updateReference(this.state.selectedRecord.referenceId, reference)}
                usPersonTitles={this.props.usPersonTitles}
                israelPersonTitles={this.props.israelPersonTitles}
                usInstitutionTitles={this.props.usInstitutionTitles}
                israelInstitutionTitles={this.props.israelInstitutionTitles}
                recipientTypes={this.props.recipientTypes} />

            <ConfirmationModal
                show={this.state.showModals.confirmationModal}
                message={this.state.selectedRecord.referenceId
                    ? `Are you sure you want to permanently delete ${this.state.selectedRecord.displayName || 'this reference'} from your references?` : ''}
                close={() => {
                    this.setState({ selectedRecord: this.initialState.selectedRecord });
                    this.toggleModal("confirmationModal");
                }}
                confirm={() => this.props.deleteReference(this.state.selectedRecord.referenceId)}
                loading={this.props.removing.loading}
                success={this.props.removing.success}
                errorMessage={this.props.removing.message} />
        </div>
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/references/ReferencesTable.jsx